import React from "react";
import styled from "styled-components";
import { Icon as RsuiteIcon } from "@rsuite/icons";


const StyledIcon = styled(RsuiteIcon)`
    && {
        /* color: "#d1d5db";
        font-weight: 500;
        font-size: 18;
        margin-right: 16; */
    }
`;

type IconsProps = {
    as?: React.ElementType | string;
    spin?: boolean;
    pulse?: boolean;
    rotate?: number | string;
    viewBox?: string;
    flip?: "horizontal" | "vertical";
    fill?: string;
    width?: number | string;
    height?: number | string;
}

const Icon: React.FC<IconsProps> = (props) => {
    return <StyledIcon {...props} />;
};

export default Icon;